import { ExportOptions, ExportPayloadSection } from '../types';
import { formatValue } from '../../../utils/managerUtils';
import applyDecimalSeparator from './applyDecimalSeparator';
import applyTextExportOptions from './applyTextExportOptions';
import resolveRawValue from './resolveRawValue';
import resolveRoundedValue from './resolveRoundedValue';

const resolveCellValue = (
  row: Record<string, unknown>,
  column: ExportPayloadSection['columns'][number],
  options: ExportOptions
): string => {
  const columnValue = resolveRoundedValue(
    row[column.name],
    column.exportOptions
  );

  if (options.useDisplayFormatting) {
    // Use the same display formatter as grids/details when the user wants decorated values.
    const formattedValue = resolveRawValue(
      formatValue(
        {
          ...row,
          [column.name]: columnValue,
        },
        column.formatConfig
      )
    );

    return applyTextExportOptions(
      applyDecimalSeparator(formattedValue, column, options),
      column.exportOptions
    );
  }

  return applyTextExportOptions(
    applyDecimalSeparator(resolveRawValue(columnValue), column, options),
    column.exportOptions
  );
};

export default resolveCellValue;
